$(function () {
  initFilters();
  initFilterLabels();
});

function initFilters() {
  $('.list-filter__container').each(function (index, item) {
    if (!$(item).data('filtersInitialized')) {
      $(item).on('click', function () {
        var wrapper = $(item).parents('.list-filter__wrapper');
        var isActive = item.hasAttribute('data-active');
        if (isActive) {
          $(item).removeAttr('data-active');
        } else {
          if (!wrapper[0].hasAttribute('data-multiple')) {
            wrapper.find('.list-filter__container').removeAttr('data-active');
          }
          $(item).attr('data-active', '');
        }
        updateFilterValues(wrapper);
      });
      $(item).data('filtersInitialized', true);
    }
  });

  $('.list-filters__label').each(function (index, item) {
    if (!$(item).data('filtersInitialized')) {
      $(item).on('click', function () {
        var container = $(item).parents('.list-filters__container');
        var isActive = container.hasClass('list-filters__container--active');
        isActive ? closeFilters(container) : openFilters(container);
      });
      $(item).data('filtersInitialized', true);
    }
  });
}

function initFilterLabels() {
  $('.list-filters__container').each(function (index, item) {
    if (!$(item).data('filtersInitialized')) {
      var filterAmount = $(item).find(
        '.list-filter__container[data-active]'
      ).length;
      var filter = $(item).find('input[name="filter"]').val();
      updateFilterLabel($(item), filterAmount, filter);
      $(item).data('filtersInitialized', true);
    }
  });
}

function openFilters(container) {
  closeFilters($('.list-filters__container'));
  container.addClass('list-filters__container--active');
  $(document).on('click.filters', function (ev) {
    if (
      !$(ev.target).hasClass('list-filters__container') &&
      !$(ev.target).parents('.list-filters__container').length
    ) {
      closeFilters(container);
    }
  });
}

function closeFilters(container) {
  container.removeClass('list-filters__container--active');
  $(document).off('click.filters');
}

function updateFilterValues(wrapper) {
  var filter = '';
  var filterAmount = 0;
  wrapper
    .parents('.list-filters__filters')
    .find('.list-filter__container')
    .each(function (index, item) {
      if (item.hasAttribute('data-active')) {
        if (filter) {
          filter += '-';
        }
        filter += $(item).attr('data-filter');
        filterAmount += 1;
      }
    });

  var inputName = wrapper.parents('.list-filters__container').attr('data-input-name') || 'filter';

  wrapper
    .parents('.list-options__container')
    .find('input[name="' + inputName + '"]')
    .val(filter);

  updateFilterLabel(
    wrapper.parents('.list-filters__container'),
    filterAmount,
    filter
  );
}

function updateFilterLabel(container, filterAmount, filter) {
  if (filterAmount) {
    container.attr('data-has-filter', '');
    if (filterAmount == 1) {
      var text = container
        .find(
          '.list-filter__container[data-filter="' +
          filter +
          '"] .list-filter__label'
        )
        .html()
        .trim();
      container.find('.list-filters__label-text').html(text);
    } else {
      var labelEl = container.find('.list-filters__label-text');
      labelEl.html(
        '{n} Filter'.replace('{n}', filterAmount)
      );
    }
  } else {
    container.removeAttr('data-has-filter');
    var labelEl = container.find('.list-filters__label-text');
    if (labelEl.attr('data-filter-text-default')) {
      labelEl.html(labelEl.attr('data-filter-text-default'));
    } else {
      labelEl.html('Filter...');
    }
  }
}
